import * as React from 'react';
import * as res from "./style.module.scss"
export const Result = () => {
  return (
    <section>
      <div className={res.after}>
        <div className="container">
          <h2>После курсов вы сможете</h2>
          <ul>
            <li>
              <p>Работать <strong>продуктивнее</strong> и без стресса</p>
            </li>
            <li>
              <p>Быстро <strong>осваивать</strong> сложное</p>
            </li>
            <li>
              <p><strong>Не тратить</strong> вечера на домашку ребёнка</p>
            </li>
            <li>
              <p>Получить <strong>новую</strong> профессию за 2 месяца</p>
            </li>
            <li>
              <p>Держать <strong>мозг</strong> в тонусе даже после 80 лет</p>
            </li>
          </ul>
        </div>
      </div>
      <div className={res.results}>
        <div className={`container ${res.container}`}>
          <div className={res.left}>
            <h2>С нами вы научитесь</h2>
            <div className={res.content}>
              <ul>
                <li>Запоминать <span>в 2–3 раза</span> быстрее</li>
                <li>Быть <span>внимательнее</span> и меньше уставать от учёбы</li>
                <li>Быстро <span>осваивать</span> иностранные языки</li>
                <li>Читать минимум <span>в 2 раза</span> быстрее</li>
              </ul>
              <img src="https://fs.advance.ru/landing-pages/about/Group-3.png" alt=""/>
            </div>
          </div>
          <div className={res.right}>
            <div className={res.img}>
              <img src="https://fs.advance.ru/landing-pages/about/Group-3.png" alt=""/>
            </div>
            <div className={res.imgs}>
              <img src="https://fs.advance.ru/landing-pages/about/Group-4.png" alt="" className={res.topImg}/>
              <img src="https://fs.advance.ru/landing-pages/about/Group-5.png" alt="" className={res.bottomImg}/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
